import React, { useRef } from 'react'
import { Spinner } from '../Loaders/Loaders'
import CartIcon from '@tecuity/sos-icons/react/cart'
import GearsIcon from '@tecuity/sos-icons/react/gears'
import DatabaseIcon from '@tecuity/sos-icons/react/database'
import RSSIcon from '@tecuity/sos-icons/react/rss'
import ReactTooltip from 'react-tooltip'
import format from 'date-fns/format'
import shortid from 'shortid'
import { usePrevious } from '../../Utilities/hooks'

const DATA_REQUEST_TOOLTIP = process.env.DATA_REQUEST_TOOLTIP
const DATA_REQUESTS_IN_SHOPPING_CART = process.env.DATA_REQUESTS_IN_SHOPPING_CART

const DATA_REQUEST_PENDING_INVALID_STATUS = 1075

const STATUSES = {
  1071: {
    text: 'Active',
    className: 'dr-active',
  },
  1072: {
    text: 'Cancelled',
    className: 'dr-cancelled',
  },
  1073: {
    text: 'Cancelled - Failed Payment',
    className: 'dr-failed',
  },
  1074: {
    text: 'Complete',
    className: 'dr-complete',
  },
  1077: {
    text: 'Paused',
    className: 'dr-paused',
  },
}

const TYPES = {
  1080: {
    text: 'Existing',
    className: 'existing',
    icon: DatabaseIcon,
  },
  1081: {
    text: 'current',
    className: 'single',
    icon: DatabaseIcon,
  },
  1082: {
    text: 'reocurring',
    className: 'subscription',
    icon: RSSIcon,
  },
}

const getStatusById = (id) => STATUSES[id] || { className: '', text: '' }
const getTypeById = (id) => TYPES[id] || { className: '', text: '' }

export default ({
  NAME,
  NAME_OVERRIDE,
  STATUS_RO,
  STATUS_ID,
  DATA_REQUEST_TYPE_ID,
  CREATED_DATE,
  onManageClicked,
  onDownloadsClicked,
  onAddToCartClicked,
  isActive,
  checkoutOpen,
}) => {
  const [checkoutPending, setCheckoutPending] = React.useState(false)
  const status = getStatusById(STATUS_ID)
  const type = getTypeById(DATA_REQUEST_TYPE_ID)
  const id = useRef(shortid.generate())
  const prevCheckoutOpen = usePrevious(checkoutOpen)

  const handleCartClicked = (e) => {
    setCheckoutPending(true)
    onAddToCartClicked(e)
  }

  React.useEffect(() => {
    if (prevCheckoutOpen === false && checkoutOpen === true) {
      setCheckoutPending(false)
    }
  }, [checkoutOpen, prevCheckoutOpen])

  return (
    <li
      className={`data-request-block ${status.className} ${type.className} ${
        isActive ? 'active' : ''
      }`}
    >
      <h2 className="dr-title-wrapper">
        <span className="dr-title">{NAME_OVERRIDE || NAME}</span>
        <span className="dr-subtitle">
          {type.icon ? <type.icon /> : null}
          <span className="date">{format(new Date(CREATED_DATE), 'MM/dd/yyyy')} - </span>
          <span className="visually-hidden">Status: </span>
          {STATUS_RO}
        </span>
      </h2>
      <div className="dr-buttons">
        {STATUS_ID === DATA_REQUEST_PENDING_INVALID_STATUS && DATA_REQUESTS_IN_SHOPPING_CART ? (
          <button
            className="fixed cart-button"
            aria-label={`Add request ${NAME} to cart`}
            onClick={handleCartClicked}
            data-for={id.current}
            data-tip={'Add to Cart'}
            disabled={checkoutPending}
          >
            {checkoutPending && !checkoutOpen ? (
              <Spinner size="medium" themeColor="dark-neutral" />
            ) : (
              <CartIcon alt='Cart icon' />
            )}
          </button>
        ) : null}
        <button
          className="fixed"
          aria-label={`Manage data request for ${NAME}`}
          onClick={onManageClicked}
          data-for={id.current}
          data-tip={DATA_REQUEST_TOOLTIP || 'View Details'}
        >
          <span className="visually-hidden">Manage data request for {NAME}</span>
          <GearsIcon alt='Manage Data Requests icon' />
        </button>
        <ReactTooltip effect="solid" id={id.current} delayShow={1000} />
        <button aria-label={`View downloads for ${NAME}`} onClick={onDownloadsClicked}>
          View Downloads
        </button>
      </div>
    </li>
  )
}



// WEBPACK FOOTER //
// ./src/components/DataRequests/DataRequestBlock.js